module.exports = __webpack_public_path__ + "img/clipboard.a2ac6519.png";